<template>
    <div>
		<nav class="navbar navbar-expand-xl navbar-light fixed-top nav-shadow">
			<div class="container-fluid">
				<a target="_blank" class="navbar-brand xl-brand" href="http://www.pxmart.com.tw/px/index.px?utm_source=%E5%85%A8%E5%BA%97%E5%8D%B0%E8%8A%B1&utm_medium=eventwebsite&utm_content=Officialwebsite">
					<img :src="logoSrc" alt="">
				</a>
				<button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarsExample04" aria-controls="#navbarsExample04" aria-expanded="false" aria-label="Toggle navigation">
					<span class="icon-bar top-bar"></span>
					<span class="icon-bar middle-bar"></span>
					<span class="icon-bar bottom-bar"></span>
					<span class="sr-only">Toggle navigation</span>
				</button>
				<div class="navbar-collapse collapse" id="navbarsExample04">
					<a target="_blank" class="nav-20 navbar-pxmartlogo navbar-brand mr-auto lg-brand" href="http://www.pxmart.com.tw/px/index.px?utm_source=%E5%85%A8%E5%BA%97%E5%8D%B0%E8%8A%B1&utm_medium=eventwebsite&utm_content=Officialwebsite">
						<img :src="logoSrc" alt="">
					</a>
					<ul class="nav-60 navbar-nav mx-auto">
						
						<div class="move-box"></div>
						<li class="nav-item navbar-index" @click="scroll_to_top"><router-link class="nav-link" to="/">首頁</router-link></li>
						<li class="nav-item navbar-brandIntro" @click="scroll_to('#brand-intro')"><router-link class="nav-link" :to="{name: 'brand-intro'}">品牌介紹</router-link></li>
						<li class="nav-item navbar-productIntro" @click="scroll_to('#product-intro')"><router-link class="nav-link" :to="{name: 'product-intro'}">商品介紹</router-link></li>
						<li class="nav-item navbar-flowerList" @click="scroll_to('#flower-list')"><router-link class="nav-link" :to="{name: 'flower-list'}">印花攻略</router-link></li>
						<!-- <li class="nav-item navbar-recipe" ><router-link class="nav-link" to="/Recipes">食譜專區</router-link></li> -->
						<li class="nav-item navbar-cardDownload" @click="scroll_to('#card-download')"><router-link class="nav-link" :to="{name: 'card-download'}">收集卡下載</router-link></li>
						<li class="nav-item navbar-actRules"><router-link class="nav-link" to="/ActRules">活動辦法</router-link></li>

						<li class="nav-item navbar-qna"><router-link class="nav-link" to="/Qna">常見問題</router-link></li>

						<li class="nav-item media-item lg-media">
							<div class="nav-link" href="">
								<span class="media-wrap nav-media-wrap">
									<a class="allshare-line-btn navbar-line-share" href="">
									<img :src="share1Src" alt="">
									
									</a>
								</span>
								<span class="media-wrap nav-media-wrap">
									<a class="allshare-fb-btn navbar-fb-share" href="">
									<img :src="share2Src" alt="">
									
									</a>
								</span>
							</div>
						</li>
					</ul>
					<ul class="nav-20 nav-right navbar-nav ml-auto xl-media">
						<li class="nav-item media-item"><div class="nav-link" href="">
						<span class="media-wrap">
						<a class="allshare-line-btn" href="">
							<img :src="share1Src" alt="">
							
						</a>
						</span>
						<span class="media-wrap">
						<a class="allshare-fb-btn" href="">
							<img :src="share2Src" alt="">
							
						</a>
						</span>
					</div></li>
					</ul>
				</div>
			</div>
		</nav>
    </div>
</template>
<script>

import logoSrc from '../assets/logo.svg';
import share1Src from '../assets/share-01.svg';
import share2Src from '../assets/share-02.svg';
import * as $ from 'jquery';



export default {
	data(){
		return {
			logoSrc,
			share1Src,
			share2Src,
			scrollTop: 0,
			banner_height: 1000,
			w_width: 0,
			processing: false
		}
	},
	computed: {
		navbar_class(){

			
		}
	},
	methods: {
		clicked(e){
			console.log(this.$route)
			console.log($(this))
			e.preventDefault();
		},
		movebox(){
			$(".navbar .nav-item").mouseover(function () {
				$(".move-box").css({
					height: $(".nav-item").outerHeight() + "px",
					width: $(this).outerWidth() - 30 + "px",
					opacity: 1
				});
				var d = $(this).offset().left;
				$(".move-box").css("left", d + 15 + "px");
			});
			$(".navbar-nav").mouseout(function () {
				$(".move-box").css("opacity", "0");
			});

			$(".xl-media").hover(function () {
				$(".move-box").css("display", "none");
			}, function () {
				$(".move-box").css("display", "block");
			});
		},
		collapsed(){
			$("body").on('click', '.nav-link', ()=>{
				$('.navbar-toggler').addClass('collapsed');
				$('.navbar-collapse').removeClass('show');
			});
		},
		scroll_to(el){

			let el_top =  (this.w_width>768)?($(el).offset().top):($(el).offset().top-50)
			//console.log(this.w_width)
			console.log(el)

			$("HTML, BODY").animate({ scrollTop: el_top}, 500);
			// if(this.processing===false){
				
			// 	this.processing = true;
			// 	this.processing_to_false();
			// }else{
			// 	return false;

			// }
			
			

		},
		scroll_to_top(){

			//console.log(this.$route.name);
			
			$("HTML, BODY").animate({ scrollTop: 0 }, 500);
			
		},
		allshare_fb(){
			
			$(".allshare-fb-btn").on("click", function (e) {
				e.preventDefault();
				var s = window.location.href;
				var hash_p = s.indexOf("#");
				var n_s = s.slice(0, hash_p+2);
				//console.log(s);
				window.open('http://www.facebook.com/share.php?u=' + encodeURIComponent(n_s));
			});
		},
		allshare_line(){
			$(".allshare-line-btn").on("click", function (e) {
				e.preventDefault();
				var s = window.location.href;
				var hash_p = s.indexOf("#");
				var n_s = s.slice(0, hash_p+2);
				

				// s = s.substring(0, i);
				window.open('https://social-plugins.line.me/lineit/share?url=' + encodeURIComponent(n_s));
			});
		},
		handleResize() {
			this.w_width = window.innerWidth;
			this.banner_height = $(".index-header").height();
			console.log(this.banner_height)
		},
		handleScroll () {
			this.scrollTop = $(window).scrollTop();
			this.banner_height = $(".index-header").height();
			//console.log($(window).scrollTop());
		},
		processing_to_false(){
			setTimeout(()=>{
				this.processing = false;
			},1500);
		}
	},
	watch: {
        '$route' (to, from) {
			console.log(this.$route.name+"!!!!!")
			if(this.$route.name === 'index'){
				setTimeout(()=>{
					this.scroll_to("header");
				},500);
				
			}
			if(this.$route.name === 'brand-intro'){
				setTimeout(()=>{
					this.scroll_to("#brand-intro");
				},500);
				
			}
			if(this.$route.name === 'product-intro'){
				setTimeout(()=>{
					this.scroll_to("#product-intro");
				},500);
				
			}
			if(this.$route.name === 'flower-list'){
				setTimeout(()=>{
					this.scroll_to("#flower-list");
				},500);
				
			}

			if(this.$route.name === 'card-download'){
				setTimeout(()=>{
					this.scroll_to("#card-download");
				},500);
				
			}

			console.log(to, from)
            if (from.name === 'product') {
				let url = window.location.href;
				let query = url.slice(url.indexOf("?"), url.indexOf("?") + 11)
				let new_url = url.replace(query, '');
				
				window.location = new_url
				
            }


// ==============

			

// ====================
 

        },
        windowWidth(new_w, old_w) {
        //this.slick_list_click();
        }
    },
	mounted(){
		this.movebox();
		this.collapsed();
		this.allshare_fb();
		this.allshare_line();

		this.banner_height = $(".index-header").height();
		console.log(this.banner_height)

		//console.log(this.$route.name);

		



		$('.navbar-index').on('click', function (e) {
			gtag('event', '點擊', {
				'event_category': 'navbar-首頁',
				'event_action': '點擊',
				'event_label': '點擊次數'
			});
		});

		$('.navbar-brandIntro').on('click', function (e) {
			gtag('event', '點擊', {
				'event_category': 'navbar-品牌介紹',
				'event_action': '點擊',
				'event_label': '點擊次數'
			});
		});
		$('.navbar-productIntro').on('click', function (e) {
			gtag('event', '點擊', {
				'event_category': 'navbar-商品介紹',
				'event_action': '點擊',
				'event_label': '點擊次數'
			});
		});
		$('.navbar-flowerList').on('click', function (e) {
			gtag('event', '點擊', {
				'event_category': 'navbar-印花清單',
				'event_action': '點擊',
				'event_label': '點擊次數'
			});
		});

		$('.navbar-recipe').on('click', function (e) {
			gtag('event', '點擊', {
				'event_category': 'navbar-食譜專區',
				'event_action': '點擊',
				'event_label': '點擊次數'
			});
		});

		$('.navbar-actRules').on('click', function (e) {
			gtag('event', '點擊', {
				'event_category': 'navbar-活動辦法',
				'event_action': '點擊',
				'event_label': '點擊次數'
			});
		});
		$('.navbar-qna').on('click', function (e) {
			gtag('event', '點擊', {
				'event_category': 'navbar-常見問題',
				'event_action': '點擊',
				'event_label': '點擊次數'
			});
		});
		//navbar-line-share
		$('.allshare-line-btn').on('click', function (e) {
			gtag('event', '點擊', {
				'event_category': 'navbar-line分享',
				'event_action': '點擊',
				'event_label': '點擊次數'
			});
		});

		$('.allshare-fb-btn').on('click', function (e) {
			gtag('event', '點擊', {
				'event_category': 'navbar-fb分享',
				'event_action': '點擊',
				'event_label': '點擊次數'
			});
		});

		
		$('.navbar-brand').on('click', function (e) {
			gtag('event', '點擊', {
				'event_category': 'navbar-官方首頁',
				'event_action': '點擊',
				'event_label': '點擊次數'
			});
		});
		

		console.log("nav!!")

		
	},
	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('scroll', this.handleScroll);
		this.handleResize();
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		window.removeEventListener('scroll', this.handleScroll);
	},
}



</script>


<style lang="sass">

*
	//border: 1px solid

@media (max-width: 768px)
	nav.navbar
		padding-top: 0
		padding-bottom: 0

nav.navbar
	.nav-right
		justify-content: flex-end

	.nav-20
		flex-basis: 20%
	.nav-60
		flex-basis: 60%
		justify-content: center

	&:after
		content: ""
		display: block
		width: 100vw
		height: 60px
		position: absolute
		top: 0
		left: 0
		opacity: 1
		background: rgba(0, 0, 0, 0.9)
		pointer-events: none
		z-index: -1
		background: linear-gradient(to bottom, black 30%, rgba(black, 0.01) 100%)
		transition: .3s
		@media (max-width: 768px)
			height: 50px
	.navbar-brand img
		width: 200px
		@media (max-width: 1320px)
			width: 150px
		@media (max-width: 1199px)
			width: 200px
	.navbar-nav
		-webkit-transition: .3s
		-o-transition: .3s
		transition: .3s
		.nav-item
			a, .nav-link
				color: #fff
				font-weight: 300
				padding-left: 20px
				padding-right: 20px
				white-space: nowrap
				letter-spacing: 2px
				position: relative
		a:hover, div.nav-link:hover
			color: white
		a
			&:before, &:after
				content: ""
				display: block
				position: absolute
				top: 50%
				left: 50%
				transform: translate(-50%, -50%)
				width: 200%
				height: 1px
				background: white
				opacity: 0
				transition: .3s
		div.nav-link
			&:before, &:after
				content: ""
				display: block
				position: absolute
				top: 50%
				left: 50%
				transform: translate(-50%, -50%)
				width: 200%
				height: 1px
				background: white
				opacity: 0
				transition: .3s
		a:before, div.nav-link:before
			top: 0
		a:after, div.nav-link:after
			top: auto
			bottom: 0 !important
		span a
			padding: 0
	.move-box
		position: absolute
		border-top: 1px solid #fff
		border-bottom: 1px solid #fff
		top: 50%
		
		transform: translateY(-50%)
		transition: .3s
		opacity: 0
		-webkit-box-sizing: border-box
		box-sizing: border-box
		pointer-events: none
	.lg-media, .xl-media
		*
			//border: 1px solid
		a
			display: inline-block
			padding: 0 !important
		.nav-link:hover
			&:before, &:after
				opacity: 0 !important
				display: none
		a:hover
			&:before, &:after
				opacity: 0 !important
				display: none
	.media-item span
		width: 70px
		display: inline-block
		margin: 0 10px
		img
			width: 100%
	.navbar-toggler
		border: none
		background: transparent !important
		text-align: right !important
		&:before
			content: ""
			width: 100vw
			height: 100vh
			background: rgba(0, 0, 0, 0.8)
			display: block
			position: absolute
			left: 0
			top: 0
			opacity: 0
			pointer-events: none
			transition: .3s
			z-index: -1
		&:focus
			outline: none
			background: transparent !important
		.icon-bar
			background-color: #fff
			transform: rotate(0deg) translate(0px, 0px)
			transition: ease all .2s
			display: block
			width: 22px
			height: 2px
			right: 0
			border-radius: 1px
			+ .icon-bar
				margin-top: 4px
	.icon-bar:nth-child(2)
		width: 16px
		transition: ease all .2s
	.navbar-toggler
		&:hover > .icon-bar:nth-child(2), &:active > .icon-bar:nth-child(2)
			width: 22px
			transition: ease all .2s
		&:not(.collapsed)
			&:before
				opacity: 1
			.icon-bar
				&:nth-child(1)
					transform: rotate(45deg) translate(5px, 4px)
					
					transition: ease all .2s
				&:nth-child(2)
					opacity: 0
					
					transition: ease all .2s
				&:nth-child(3)
					
					transform: rotate(-45deg) translate(4px, -4px)
					
					transition: ease all .2s

@media (max-width: 768px)
	nav.navbar:after
		background: #222

@media (max-width: 576px)
	nav.navbar .navbar-brand img
		position: relative
		top: 3px
		width: 150px

@media (min-width: 1200px)
	nav.navbar
		.xl-brand, .lg-media
			display: none

@media (max-width: 1199px)
	nav.navbar
		.lg-brand, .xl-media
			display: none

@media (max-width: 1199px)
	nav.navbar .navbar-nav .nav-item
		a:hover
			&:before, &:after
				opacity: 1
		div.nav-link:hover
			&:before, &:after
				opacity: 1

@media (max-width: 1490px)
	nav.navbar .navbar-nav .nav-item
		a, .nav-link
			padding-left: 15px
			padding-right: 15px

@media (max-width: 1410px)
	nav.navbar .navbar-nav .nav-item
		a, .nav-link
			padding-left: 10px
			padding-right: 10px

@media (max-width: 1264px)
	nav.navbar .navbar-nav .nav-item
		a, .nav-link
			padding-left: 5px
			padding-right: 5px

@media (max-width: 1199px)
	nav.navbar .navbar-nav .nav-item
		
		display: flex
		text-align: center
		height: calc(90vh/9)
		align-items: center
		justify-content: center

@media (max-width: 1199px)
	nav.navbar .navbar-nav .move-box
		display: none !important

@media (max-width: 576px)
	nav.navbar .navbar-toggler
		margin-top: 8px

nav.index-navbar
	&:after
		opacity: 0
		@media (max-width: 768px)
			opacity: 1
			background-color: #222
	.navbar-nav
		.nav-item
			a, .nav-link
				color: black
				@media (max-width: 1199px)
					color: white !important
	.move-box
		border-top: 1px solid black
		border-bottom: 1px solid black
		@media (max-width: 991px)
			border-top: 1px solid white
			border-bottom: 1px solid white

nav.recipe
	&:after
		background: white
	.navbar-nav
		.nav-item
			a, .nav-link
				color: black
				@media (max-width: 1199px)
					color: white !important
	.move-box
		border-top: 1px solid black
		border-bottom: 1px solid black
		@media (max-width: 991px)
			border-top: 1px solid white
			border-bottom: 1px solid white
	.navbar-toggler
		.icon-bar
			background: #000

		
		

</style>



// WEBPACK FOOTER //
// src/subview/Navbar.vue